import { Component, OnInit } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { BaseComponentConfig, BreadCrumbData, ComponentConfig,ConfigOptions, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { borderRightStyle } from 'html2canvas/dist/types/css/property-descriptors/border-style';
import { FORMS } from '../forms';
import { SETTINGS as settings } from '../model';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';

@Component({
  selector: 'ubs-web-site',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./web-site.component.scss']
})
export class WebSiteComponent extends BaseComponentConfig {
  breadCrumbs:BreadCrumbData[];
  options:ConfigOptions = {
    name:"Name",
    title:"Websites",
    idFieldName:"webSiteId",
    addForm:new OfbizForm({
      formName:"EditWebSite",
      entityName:"WebSite",
      formLocation:"component://content/widget/website/WebSiteForms.xml",
      target:"listFindWebSite",
    }),
    listForm:new OfbizList({
      fieldFormName:"FindWebSite",
      fieldFormLocation:"local",
      fieldFormFields:this.getFields("FindWebSite",FORMS),
      listFormName:"ListWebSites",
      entityName:"WebSite",
      listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
      columnFields:this.getFields("ListWebSites",FORMS),
      endPoint:"listFindWebSite",
      emptyListMessage:"",
      viewIndex:1,
      findParameters:[
        {"noConditionFind":"Y"}
      ],
      actions:{
        position:"right",
        delete:false,
        custom:[
          {
            name:'linkedList',
            title:'<i class="nb-list" title="Linked List"></i>'
          }
        ]
      },
    }),
    findForm:new OfbizForm({
      formName:"FindWebSite",
      entityName:"WebSite",
      formLocation:"component://commonforms/widget/CommonFormsForms.xml",
      target:"listFindWebSite",
    }),
    actions:["list","find","add","edit"],
    breadCrumbData:{
      displayPrefix:"Websites",
      label:"",
      level:1,
      selectedValue:{
          "event":"list",
          "type":"ListWebSites",
          "data":{
            "formData":{
              "formName":"ListWebSites",
              "formLocation":"component://commonforms/widget/CommonFormsForms.xml",
              "noConditionFind":"Y"
            },
            "endPoint":"listFindContent",
          },
      },
      addFormText:"Create New Website",
      editFormText:"Update Website",
    },
    settings:settings,
    childComponent:new ComponentConfig({
      name:"Name",
      title:"Blogs",
      idFieldName:"contentId",
      lookUpEndPoint:"LookupContent",
      searchResults:null,
      listForm:new OfbizList({
        fieldFormName:"FindWebSiteContent",
        fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        fieldFormFields:this.getFields("FindWebSiteContent",FORMS),
        listFormName:"ListWebSiteContent",
        entityName:"WebSiteContent",
        listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        endPoint:"listFindWebSiteContent",
        columnFields:this.getFields("ListWebSiteContent",FORMS),
        emptyListMessage:"",
        viewIndex:1,
      }),
      addForm:new OfbizForm({
        formName:"CreateWebSiteContent",
        entityName:"WebSiteContent",
        formLocation:"component://content/widget/website/WebSiteForms.xml",
      }),
      findForm:new OfbizForm({
        formName:"FindWebSiteContent",
        entityName:"WebSiteContent",
        formLocation:"component://commonforms/widget/CommonFormsForms.xml",
        target:"listFindWebSiteContent",
      }),
      actions:["list","find","add","edit"],
      breadCrumbData:{
        displayPrefix:"Website content for ",
        label:"",
        level:2,
        selectedValue:{
          "event":"list",
          "type":"ListWebSiteContent",
          "data":{
            formData:{
              "formName":"ListWebSiteContent",
              "formLocation":"component://commonforms/widget/CommonFormsForms.xml",
            },
            "endPoint":"listFindWebSiteContent"
          }
        },
        addFormText:"Create New Website Content",
        editFormText:"Update Website Content",
      },
    })
  };

  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService,) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(this.options);
    console.log("WebSiteComponent",this.componentConfig)
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
  }


}
